import '../../App.css';
import React, { useContext, useEffect } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import ModalCadastrarEmpresa from '../../components/modal/ModalCadastrarEmpresa'
import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Page, Toolbar, Sort } from '@syncfusion/ej2-react-grids';
import { L10n } from '@syncfusion/ej2-base';
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { StyleContext } from '../../context/StyleContext';

function CadastroEmpresa() {
    const { Empresas, Success, Error, openModal, setOpenModal, ListaEmpresas, loading, Permissao } = useContext(ApiContext)
    const { h3Demanda, btnCriar } = useContext(StyleContext)
    const toolbarOptions = ['Search'];

    L10n.load({
        'pt-BR': {
            grid: {
                EmptyRecord: 'Nenhum registro encontrado',
            },
        },
    });

    const gridTemplate = (props) => {
        return (
            <tr className='tr-ciclo'>
                <td className="td-ciclo">{props.label}</td>
                <td className="td-ciclo">{props.cnpj}</td>
                <td className="td-ciclo">{props.telefone}</td>
                <td className="td-ciclo">{props.email}</td>
                <td className="td-ciclo">
                    {(props.ativo.toString() == 'true') ? (
                        <div className="item-ativo">⬤</div>
                    ) : (
                        <div className="item-inativo">⬤</div>
                    )}
                </td>
            </tr>);
    };

    useEffect(() => {
        ListaEmpresas("")
    }, [])

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar empresa'}></Header>
            <MenuLateral></MenuLateral>
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarEmpresa closeModal={setOpenModal} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar empresa</button>
                    }
                </div>
                {loading ? (
                    <div className="loading-screen">
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                ) : (
                    <div className='card card-table'>
                        <h3 className='h3-demanda' style={h3Demanda}>Empresas cadastradas</h3>
                        <GridComponent locale='pt-BR' id="grid" dataSource={Empresas} toolbar={toolbarOptions} rowTemplate={gridTemplate} allowSorting={true} allowPaging={true} pageSettings={{ pageSize: 10, pageCount: 5 }}>
                            <ColumnsDirective>
                                <ColumnDirective field='label' headerText='Razão Social' />
                                <ColumnDirective field='cnpj' headerText='CNPJ' />
                                <ColumnDirective field='telefone' headerText='Telefone' />
                                <ColumnDirective field='email' headerText='E-mail' />
                                <ColumnDirective field='ativo' headerText='Status' />
                            </ColumnsDirective>
                            <Inject services={[Page, Sort, Toolbar]} />
                        </GridComponent>
                    </div>
                )}
            </div>
            <Footer></Footer>
        </div>
    );
}

export default CadastroEmpresa;